import { fetchApi } from '@/config/axiosSetting';
import {
  GetVehicleInformationType,
  getVehicleInitialInformationType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getVehicleInformation.type';

export const getVehicleInitialInformationFunction = ({
  id,
}: getVehicleInitialInformationType): Promise<GetVehicleInformationType> => {
  return fetchApi.get(`initial/reports/${id}/vehicle_information/`, {
    params: {
      id,
    },
  });
};
